import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const userData = {
  firestorePath: '/user-data',
  firestoreRefType: 'collection', // or 'doc'
  moduleName: 'userData',
  statePropName: 'userData',
  namespaced: true, // automatically added
  // this object is your store module (will be added as '/myModule')
  // you can also add state/getters/mutations/actions

  state, getters, mutations, actions
}

export default userData